/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable operator-linebreak */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classNames from 'classnames';
import UserPlaylists from '../Tabs/UserPlaylists';
import SparkyardPlaylists from '../Tabs/SparkyardPlaylists';
import SharedPlaylists from '../Tabs/SharedPlaylists';
import SortingDropdown from '../SortingDropdown';
import { sortings } from '../datas';
import useGetPlaylistsLazy from '../../../hooks/Playlist/useGetPlaylistsLazy';
import { displayLoadingMessage } from '../../../utils/helpers';

const MainSection = () => {
  const {
    data: userPlaylists,
    loading: loadingUserPlaylists,
    loadPlaylists: loadUserPlaylists,
  } = useGetPlaylistsLazy('user');

  const {
    data: syPlaylists,
    loading: loadingSyPlaylists,
    loadPlaylists: loadSyPlaylists,
  } = useGetPlaylistsLazy('sy');

  const {
    data: sharedPlaylists,
    loading: loadingSharedPlaylists,
    loadPlaylists: loadSharedPlaylists,
  } = useGetPlaylistsLazy('shared');

  (loadingUserPlaylists || loadingSyPlaylists || loadingSharedPlaylists) &&
    displayLoadingMessage();

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [loadedTabs, setLoadedTabs] = useState(new Set());

  const toggleTab = (tab) => {
    if (activeTabIndex !== tab) {
      setActiveTabIndex(tab);
      // Load data for the tab if not already loaded
      if (!loadedTabs.has(tab)) {
        const loadFunctions = [
          loadUserPlaylists,
          loadSyPlaylists,
          loadSharedPlaylists,
        ];
        loadFunctions[tab]?.();
        setLoadedTabs((prev) => new Set([...prev, tab]));
      }
    }
  };

  // Load the first tab by default on component mount
  useEffect(() => {
    if (!loadedTabs.has(0)) {
      loadUserPlaylists?.();
      setLoadedTabs((prev) => new Set([...prev, 0]));
    }
  }, [loadUserPlaylists, loadedTabs]);

  const [selectedSorting, setSelectedSorting] = useState(sortings[0].value);

  const sortPlaylists = (value) => {
    setSelectedSorting(value);
  };

  const sortedUserPlaylists = useMemo(() => {
    const userPlaylistsLocal = userPlaylists
      ? [...userPlaylists.playlists]
      : [];

    switch (selectedSorting) {
      case 'date-created':
        return userPlaylistsLocal.sort(
          (a, b) => parseInt(b.id, 10) - parseInt(a.id, 10)
        );

      case 'a-to-z':
        return userPlaylistsLocal.sort((a, b) => a.name.localeCompare(b.name));
      case 'manual':
        return userPlaylistsLocal;
      default:
        return userPlaylistsLocal;
    }
  }, [selectedSorting, userPlaylists]);

  const sortedSyPlaylists = useMemo(() => {
    const syPlaylistsLocal = syPlaylists ? [...syPlaylists.playlists] : [];

    switch (selectedSorting) {
      case 'date-created':
        return syPlaylistsLocal.sort(
          (a, b) => parseInt(b.id, 10) - parseInt(a.id, 10)
        );
      case 'a-to-z':
        return syPlaylistsLocal.sort((a, b) => a.name.localeCompare(b.name));
      default:
        return syPlaylistsLocal;
    }
  }, [selectedSorting, syPlaylists]);

  const sortedSharedPlaylists = useMemo(() => {
    const sharedPlaylistsLocal = sharedPlaylists
      ? [...sharedPlaylists.playlistsSharedWithOrganisation]
      : [];

    switch (selectedSorting) {
      case 'date-created':
        return sharedPlaylistsLocal.sort(
          (a, b) => parseInt(b.id, 10) - parseInt(a.id, 10)
        );
      case 'a-to-z':
        return sharedPlaylistsLocal.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      default:
        return sharedPlaylistsLocal;
    }
  }, [selectedSorting, sharedPlaylists]);

  const tabs = useMemo(
    () => [
      {
        id: 'my-playlists',
        title: 'My Playlists',
        component: (
          <UserPlaylists
            isLoading={loadingUserPlaylists}
            playlists={sortedUserPlaylists}
            showDragIcon={selectedSorting === 'manual'}
          />
        ),
      },
      {
        id: 'sparkyard-playlists',
        title: 'Sparkyard Playlists',
        component: (
          <SparkyardPlaylists
            isLoading={loadingSyPlaylists}
            playlists={sortedSyPlaylists}
          />
        ),
      },
      {
        id: 'shared-with-me',
        title: 'Shared with me',
        component: (
          <SharedPlaylists
            isLoading={loadingSharedPlaylists}
            playlists={sortedSharedPlaylists}
          />
        ),
      },
    ],
    [
      loadingUserPlaylists,
      sortedUserPlaylists,
      selectedSorting,
      loadingSyPlaylists,
      sortedSyPlaylists,
      loadingSharedPlaylists,
      sortedSharedPlaylists,
    ]
  );

  const filteredSortings = useMemo(() => {
    const currentTab = tabs[activeTabIndex];
    return sortings.filter((sorting) =>
      sorting.availableFor.includes(currentTab.id)
    );
  }, [tabs, activeTabIndex]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get('tab') || '';

  useEffect(() => {
    const index = tabs.findIndex((tab) => tab.id === activeTab);
    if (index >= 0) {
      setActiveTabIndex(index);
      // Load data for the tab if not already loaded
      if (!loadedTabs.has(index)) {
        const loadFunctions = [
          loadUserPlaylists,
          loadSyPlaylists,
          loadSharedPlaylists,
        ];
        loadFunctions[index]?.();
        setLoadedTabs((prev) => new Set([...prev, index]));
      }
    }
  }, [
    activeTab,
    loadUserPlaylists,
    loadSyPlaylists,
    loadSharedPlaylists,
    loadedTabs,
    tabs,
  ]);

  return (
    <section className="main__container">
      <div className="px__sm-3">
        <div className="w-full max-w-mdX px-2 py-16 sm:px-0">
          <div className="d-flex flex-column flex-md-row justify-content-between">
            <Nav className="nav-tabs-simple mb-4 mb-md-0">
              {tabs.map((tab, index) => (
                <NavItem key={tab.id}>
                  <NavLink
                    className={classNames({ active: activeTabIndex === index })}
                    onClick={() => {
                      toggleTab(index);
                    }}
                  >
                    {tab.title}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <SortingDropdown
              sortings={filteredSortings}
              onChange={sortPlaylists}
            />
          </div>
          <TabContent activeTab={activeTabIndex} className="pt-5">
            {tabs.map((tab, index) => (
              <TabPane key={tab.id} tabId={index}>
                {tab.component}
              </TabPane>
            ))}
          </TabContent>
        </div>
      </div>
    </section>
  );
};

export default MainSection;
